import { createStore, createEffect } from "effector";
import { unpackServerData } from "../../../common/functions";
import axios from "axios"
import { IContractorDem, IQueryContratorDemsResult, IQueryNewOrder } from "./types";
import { getUuidAndSession } from "../../../common/localStorage";
import { getCustomUserAgent } from "../../../common/customUserAgent";


export const $contractorDems = createStore<IQueryContratorDemsResult>({
  loading: false,
  failMsg: "",
  services: [],
  groups: []
})

export const queryContractorDems = createEffect<string, IQueryContratorDemsResult>();

$contractorDems.on(queryContractorDems.doneData, (_, val) => val);

queryContractorDems.use((comid) =>
  axios.post("https://izba.kras-abs.ru/api/v3/demand/contractorDemands", {
    ...getUuidAndSession(),
    companyId: comid,
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent(),
      }
    }).then((resp) => {
      // let data = unpackServerData(resp.data, "getContractorDemands")
      let data={data:resp.data, failMsg:""}
      return getQueryContarctorDemsResObj(data.failMsg, data.data)
    }).catch(e => {
      let msg = e.message
      if(e.response && e.response.data) {
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          return getQueryContarctorDemsResObj(data.failMsg)
        }
      }
      return getQueryContarctorDemsResObj(msg)
    })
);

function getQueryContarctorDemsResObj( failMsg: string = "", conDems: IContractorDem | null = null ): IQueryContratorDemsResult {
  let ret = {
    loading: false,
    failMsg: failMsg,
    services: [],
    groups: []
  } as IQueryContratorDemsResult;
  if( conDems != null && "orderGroups" in conDems) {
    ret.groups = conDems.orderGroups
  }
  if( conDems != null && "contractorServices" in conDems) {//@ts-ignore
    ret.services = conDems.contractorServices
  }
  return ret
}



//////////////
export const queryNewOrder = ({ data, setLoading, setFailMsg, setDems }: IQueryNewOrder) => {
  setLoading(true)
  axios.post("https://izba.kras-abs.ru/api/v3/demand/setPaidDemand", data ,{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      }
    }).then((resp) => {
      // let data = unpackServerData(resp.data, "setDemands.insertData")
      setFailMsg(resp.data.error)
      if(resp.data.error.length == 0) setDems(resp.data.demands)
      setLoading(false)
      
    }).catch(e => {
      let msg = e.message
      if(e.response && e.response.data) {
        // let data = unpackServerData(e.response.data)
        if(e.data.failMsg != "") {
          msg = e.data.failMsg
        }
      }
      setFailMsg(msg)
      setDems([])
      setLoading(false)
    })
};


export const endWordOfBasketTitle = (servCount: number) => {
  switch(servCount % 10){
    case 1: return servCount == 11 ? "услуг" : "услуга"
    case 2:
    case 3:
    case 4: return servCount > 11 && servCount < 15 ? "услуг" : "услуги"
    default: return "услуг"
  }
}